import { gql } from '@apollo/client';

import { ResponsiveImageFragment } from 'approot/shared/graphql/responsive-images/responsive-images.graphql';

export const assessmentHeroImageFragment = gql`
  fragment AssessmentHeroImageFragment on Assessment {
    id
    name
    duration
  }
`;

export const assessmentLandscapeImageFragment = gql`
  fragment AssessmentLandscapeImageFragment on Assessment {
    landscapeImage {
      ...ResponsiveImageFragment
    }
  }
  ${ResponsiveImageFragment}
`;

export const assessmentSquareImageFragment = gql`
  fragment AssessmentSquareImageFragment on Assessment {
    squareImage {
      ...ResponsiveImageFragment
    }
  }
  ${ResponsiveImageFragment}
`;

export const UPDATE_HERO_IMAGE = gql`
  mutation UpdateAssessmentHeroImage($input: UpdateAssessmentHeroImageInput!) {
    updateAssessmentHeroImage(input: $input) {
      ...AssessmentHeroImageFragment
      ...AssessmentSquareImageFragment
      ...AssessmentLandscapeImageFragment
    }
  }
  ${assessmentHeroImageFragment}
  ${assessmentSquareImageFragment}
  ${assessmentLandscapeImageFragment}
`;
